<template>
    <BreadCrumb PageTitle="Liste des avis sur les talents" />
    <ListeAvisTalents/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeAvisTalents from "../../components/AvisTalents/ListeAvisTalents.vue";

    export default defineComponent({
      name: "ListeAvisTalentsPage",
      components: {
        BreadCrumb,
        ListeAvisTalents,
      },
    });
  </script>